
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Element } from '@/models'
import ApiClient from '@/services/api-client'
import { MutationTypes } from '@/store/mutation-types'
import { Utils } from '@/utils'

@Component({
  components: {}
})
export default class StructureNameField extends Vue {
  @Prop({ required: true, type: Object }) element: Element
  @Prop({ required: true, type: Boolean }) readonly isEditable: boolean

  private Utils = Utils

  private nameInter = ''
  private editField = false

  created() {
    this.resetFromOrigin()
  }

  @Watch('element', { deep: true })
  onElementChanged() {
    this.resetFromOrigin()
  }

  private resetFromOrigin() {
    this.nameInter = this.element.name
  }

  private activeEditField() {
    if (!this.isEditable) {
      return
    }
    this.editField = true
  }

  private cancelEditField() {
    this.resetFromOrigin()
    this.editField = false
  }

  private focusout() {
    setTimeout(() => {
      this.cancelEditField()
    }, 1000)
  }

  private getElementTypeName(codeId: string) {
    return Utils.findElementTypeName(codeId, this.$store.getters.elementTypes)
  }

  private updateField() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.updateElementName(this.element.id, this.nameInter)
      .then((element: Element) => {
        this.$emit('elementUpdated', element)
        this.editField = false
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: Error) => {
        console.log('Error form', ex)
        this.$store.commit(MutationTypes.SET_LOADING, false)
        alert(`Error: ${ex.message}`)
      })
  }
}
